// Shared by world.ts and levels.ts (levels use on() from src/core/level-helpers.ts)
export const K = 'attic';
